import { Component, Inject, OnInit } from '@angular/core';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { DataProductsService } from 'src/app/views/data-products/data-products.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-data-modal',
    templateUrl: './data-modal.component.html',
    styleUrls: ['./data-modal.component.scss']
})
export class DataModalComponent implements OnInit {
    dataFields: any[] = [];
    dataSample: any[] = [];
    columns: string[] = [];

    totalItems = 0;
    currentPage = 1;
    pageSize = 10;
    pageSizeOptions = [10, 20, 50, 100];

    loading = false;

    constructor(
        private modal: NzModalRef,
        @Inject(NZ_MODAL_DATA) public data: any,
        private dataProductsService: DataProductsService
    ) { }

    ngOnInit(): void {

        this.loadData(this.currentPage, this.pageSize);
    }

    async loadData(page: number, limit: number): Promise<void> {
        this.loading = true;

        const req = this.data.getQueryBody();
        req.page = page;
        req.limit = limit;

        const res: any = await firstValueFrom(this.dataProductsService.queryDataset(req));
        this.loading = false;

        if (!res?.status) return;
        this.dataFields = res.data?.fields || [];
        this.dataSample = res.data?.dataDetail || [];
        this.columns = Object.keys(this.dataSample[0] || {});
        this.totalItems = res.data?.num;
        this.currentPage = res.data?.currentPage;
        this.pageSize = req.limit;
    }

    onPageChange(page: number): void {
        this.loadData(page, this.pageSize);
    }

    onPageSizeChange(limit: number): void {
        this.loadData(1, limit);
    }

    close(): void {
        this.modal.destroy();
    }
}
